import React, { useState } from 'react';
import styles from './PredefinedPhrasesDiscourseSelection.module.scss';
import FlatList from '../../../../Base/Components/FlatList';
import ScrollContainer from '../../../../Base/Components/ScrollContainer';
import useFlatData from '../../../../Base/Hooks/useFlatData';
import {
	PhraseType,
	useLazyDiscoursePhrasesQuery,
} from '../../../../../graphql/graphql';
import LinkButton from '../../../../../Components/Button/LinkButton';
import { Theme } from '../../../../../Enums/Theme.enum';
import PredefinedPhrasesSetupModal from '../../PredefinedPhrasesSetup/PredefinedPhrasesSetupModal';
import PredefinedPhrasesDiscourseSelectionItem from './PredefinedPhrasesDiscourseSelectionItem';
import { PredefineDiscoursePhrase } from '../PredefinedPhrasesDiscourseSetup';
import useDiscoursePredefinedPhrases from '../../../Hooks/useDiscoursePredefinedPhrases';
import Loading from '../../../../../Components/Loading';

interface Props {
	onSelect: (item: PredefineDiscoursePhrase) => void;
}

const WRAPPER_ID = 'predefinedPhraseSelectionWrapper';

const PredefinedPhrasesDiscourseSelection: React.FC<Props> = ({ onSelect }) => {
	const [getMyPhrasesQuery, { data, isLoading }] =
		useLazyDiscoursePhrasesQuery();
	const [isSetupOpen, setIsSetupOpen] = useState(false);

	const { getMyPhrases, getNextPage, page, setPage } =
		useDiscoursePredefinedPhrases(getMyPhrasesQuery);

	const {
		flatData,
		hasMoreData,
		loadData,
		isLoading: isFlatDataLoading,
	} = useFlatData(
		getMyPhrases,
		{
			data: data?.documents?.data,
			totalPages: data?.documents?.meta?.totalPages,
			page: data?.documents?.meta?.page,
		},
		page,
		setPage,
	);

	if (isLoading || isFlatDataLoading) {
		return <Loading />;
	}

	return (
		<div className={styles.wrapper}>
			<div className={styles.controls}>
				<LinkButton
					title='base.phrasesSetup'
					theme={Theme.BLUE}
					onClick={() => setIsSetupOpen(true)}
				/>
				{isSetupOpen && (
					<PredefinedPhrasesSetupModal
						isOpen
						onClose={() => setIsSetupOpen(false)}
						onEdit={loadData}
						type={PhraseType.Discourse}
					/>
				)}
			</div>
			<ScrollContainer wrapperId={WRAPPER_ID}>
				<FlatList
					onRefresh={loadData}
					onLoadMore={getNextPage}
					data={flatData}
					isLoading={isLoading}
					hasMoreData={hasMoreData}
					scrollableTargetId={WRAPPER_ID}
					itemKey={'id'}
					className={styles.list}
					renderItem={item => (
						<PredefinedPhrasesDiscourseSelectionItem
							item={item}
							onSelect={onSelect}
						/>
					)}
				/>
			</ScrollContainer>
		</div>
	);
};

export default PredefinedPhrasesDiscourseSelection;
